export default __webpack_public_path__ + "static/media/address.f0c537a2.svg";